import {efaAddressBook} from './address-book-de.i18n.';


export const de = {
  efaAddressBook
};
